module.exports = __webpack_public_path__ + "img/AnnJefferson.58e50e76.jpg";